// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"9265818a","86":"be11c041","99":"cf343c09","224":"86c0ab9a","940":"b6bd5df9"}[chunkId] + ".chunk.js";
};